module.exports = __webpack_public_path__ + "media/images/panels/panel-1-onlinedruck-einfach-87929568bb81042f65d5c904ba509577.jpg";